import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import Datetime from 'react-datetime'
import {CalendarToday} from '@mui/icons-material'
import Popover from '@mui/material/Popover'
import {injectIntl} from 'react-intl'
import {getDefaultValue, isMobile} from 'utils/utils'
import environment from 'utils/enums/environment'
import './datepicker.css'

const InputCell = styled.input`
    width: 100%;
    height: 100%;
    padding: ${props => props.padding ? props.padding : '0 10px'};
    opacity: ${props => props.lookup ? 0.5 : 1};

    ~ svg {
        margin: ${props => props.padding ? props.padding : '0 10px'};
        height: 100%;
        font-size: 18px;
        cursor: pointer;
        color: ${props => props.open ? '#415dd4' : ''};
    }

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    :focus {
        + div {
            transform: scaleX(1);
            display: block;
        }
    }
`

class Date extends React.PureComponent {
    constructor(props) {
        super(props)

		this.mobile = isMobile()
        const timeFormat = this.getTimeFormat(props.config)

        let formattedValue

        if (props.defaultValue && moment(props.defaultValue, moment.ISO_8601).isValid()) {
            if (props.config) {
                if (props.config.timezone) {
                    formattedValue = moment.tz(props.defaultValue, props.config.timezone).format(props.config.format)
                } else {
                    formattedValue = moment(props.defaultValue).format(props.config.format)
                }
            } else {
                formattedValue = moment(props.defaultValue).format('DD MMM YYYY')
            }
        } else {
            formattedValue = ''
        }

        this.state = {
            anchorEl: null,
            formattedValue,
            value: moment(props.defaultValue, moment.ISO_8601).isValid() ? moment(props.defaultValue) : moment(),
            format: props.config ? props.config.format : 'DD MMM YYYY',
            timeFormat: timeFormat
        }
    }

    componentDidUpdate(props) {
        if (this.props.environment) {
            if (props.intl.locale !== this.props.intl.locale || props.defaultValue !== this.props.defaultValue) {
                this.setState({
                    formattedValue: this.props.defaultValue ? moment(this.props.defaultValue).format(this.props.config ? this.props.config.format : 'DD MMM YYYY') : '',
                    value: moment(this.props.defaultValue)
                })
            }
        }

        if (props.config && this.props.config && props.config.format !== this.props.config.format) {
            const timeFormat = this.getTimeFormat(this.props.config)

            this.setState({
                formattedValue: this.props.defaultValue ? moment(this.props.defaultValue).format(this.props.config ? this.props.config.format : 'DD MMM YYYY') : '',
                value: moment(this.props.defaultValue),
                format: this.props.config ? this.props.config.format : 'DD MMM YYYY',
                timeFormat: timeFormat
            })
        }

        if (props.config && this.props.config && props.config.timezone !== this.props.config.timezone) {
            let formattedValue
            if (this.props.config.timezone) {
                formattedValue = !this.props.defaultValue ? '' : moment.tz(this.props.defaultValue, this.props.config.timezone).format(this.props.config ? this.props.config.format : 'DD MMM YYYY')
            } else {
                formattedValue = !this.props.defaultValue ? '' : moment(this.props.defaultValue).format(this.props.config ? this.props.config.format : 'DD MMM YYYY')
            }

            this.setState({
                formattedValue
            })
        }
    }

    getTimeFormat(config) {
        let timeFormat
        if (config && config.format) {
            if (config.type === 'dateonly') {
                timeFormat = false
            } else {
                const index = config.format.indexOf('H') !== -1 ? config.format.indexOf('H') : config.format.indexOf('h')
                timeFormat = index !== -1 ? config.format.slice(index) : false
            }
        } else {
            timeFormat = 'HH:mm'
        }

        return timeFormat
    }

    handleClick = (e) => {
        if (this.props.environment && !this.props.defaultValue) {
            const value = getDefaultValue(this.props.environment, this.props.name, this.props.row)

            if (value) {
                this.setState({
                    formattedValue: moment(value).format(this.state.format),
                    value: moment(value),
                    anchorEl: e.currentTarget
                }, () => this.props.handleUpdateValue(value, this.props.name))
            } else {
                this.setState({
                    anchorEl: e.currentTarget
                })
            }
        } else {
            this.setState({
                anchorEl: e.currentTarget
            })
        }
    }

    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    }

    onBlur = (e) => {
        if (this.props.environment) {
            if (this.state.previousValue !== e.currentTarget.value) {
				const date = moment(e.currentTarget.value, this.state.format, true)
                if (date.isValid()) {
					const valid = this.checkDate(date)

					if (valid) {
						this.setState({
							value: moment(e.currentTarget.value, this.state.format),
							formattedValue: moment(e.currentTarget.value, this.state.format).format(this.state.format)
						}, () => this.props.handleUpdateValue(this.state.value.toISOString(), this.props.name))
					} else {
						this.setState({
							value: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format) : moment(),
							formattedValue: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format).format(this.state.format) : ''
						})
					}
                } else if (e.currentTarget.value === '') {
                    this.setState({
                        value: moment(),
                        formattedValue: ''
                    }, () => this.props.handleUpdateValue(this.state.formattedValue, this.props.name))
                } else {
                    this.setState({
                        value: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format) : moment(),
                        formattedValue: this.state.previousValue !== '' ? moment(this.state.previousValue, this.state.format).format(this.state.format) : ''
                    })
                }
            }
        }
    }

    handleSelectDate = (value) => {
        this.setState({
            value,
            formattedValue:  moment(value).format(this.state.format)
        }, () => this.props.handleUpdateValue(value.toISOString(), this.props.name))
    }

    onChange = (e) => {
        if (!this.props.environment) {
            if (moment(e.currentTarget.value, this.state.format, true).isValid()) {
                this.setState({
                    value: moment(e.currentTarget.value, this.state.format),
                    formattedValue: moment(e.currentTarget.value, this.state.format).format(this.state.format)
                }, () => this.props.handleUpdateValue(this.state.value.toISOString(), this.props.name))
            } else {
                this.setState({
                    formattedValue: e.currentTarget.value
                }, () => this.props.handleUpdateValue(null, this.props.name))
            }
        } else {
            this.setState({
                formattedValue: e.currentTarget.value
            })
        }
    }

    onFocus = (e) => {
        if (this.props.environment && !e.currentTarget.value) {
            const value = getDefaultValue(this.props.environment, this.props.name, this.props.row)

            if (value) {
                this.setState({
                    previousValue: e.currentTarget.value,
                    formattedValue: moment(value).format(this.state.format),
                    value: moment(value)
                }, () => this.date.select())
            } else {
                this.setState({
                    previousValue: e.currentTarget.value
                })
            }
        } else {
            this.setState({
                previousValue: e.currentTarget.value
            })
        }
    }

	checkDate = (current) => {
		if (this.props.min && this.props.max) {
			return current.isAfter(moment(this.props.min)) && current.isBefore(moment(this.props.max))
		} else if (this.props.min) {
			return current.isAfter(moment(this.props.min))
		} else if (this.props.max) {
			return current.isBefore(moment(this.props.max))
		}

		return true
	}

    render() {
		const readonly = (this.mobile && this.props.environment === environment.Collection) || this.props.readonly

        return (
            <React.Fragment>
                <InputCell
                    ref={el => this.date = el}
                    value={this.state.formattedValue}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    lookup={this.props.lookup}
                    padding={this.props.padding}
                    disabled={this.props.readonly}
                    open={!!this.state.anchorEl}
                />
                {!this.props.lookup && !readonly && <div />}
                {!readonly &&
                    <CalendarToday
                        onClick={this.handleClick}
                    />
                }
                {this.state.anchorEl &&
                    <Popover
						PaperProps={{
							style: {
								margin: '0 15px'
							}
						}}
                        open={true}
                        anchorEl={this.state.anchorEl}
                        onClose={this.handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                    >
                        <Datetime
                            dateFormat={this.state.format}
                            timeFormat={this.state.timeFormat}
                            input={false}
                            open={true}
                            value={this.state.value}
                            onChange={this.handleSelectDate}
                            displayTimeZone={this.props.config ? this.props.config.timezone : null}
							isValidDate={this.checkDate}
                        />
                    </Popover>
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(Date)
